import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import AddEditReasonWidget, { REASON_TYPE } from '../AddEditReason/AddEditReasonWidget';
import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface ViewCustomersPageProps extends IAppPropsWithRoute {
};

function ReasonsForCalloutPage(props: ViewCustomersPageProps): JSX.Element {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])

    return (
        <>
            <AddEditReasonWidget reasonType={REASON_TYPE.CALLOUT} />
        </>
    );
}

export default React.memo(withRouter(ReasonsForCalloutPage));